import { useCallback, useSyncExternalStore } from 'react';

// Thao tác giả lập: giờ chấm ra ghi trong bộ nhớ (chưa ghi DB), giữ khi chuyển màn. Khoá `${owner}:${day}`.
let outs: ReadonlyMap<string, string> = new Map();
const subs = new Set<() => void>();
const setOut = (key: string, v: string | null) => {
  const m = new Map(outs);
  if (v) m.set(key, v);
  else m.delete(key);
  outs = m;
  subs.forEach((f) => f());
};
const subscribe = (f: () => void) => {
  subs.add(f);
  return () => void subs.delete(f);
};

/** Giờ chấm ra đã ghi trong phiên. `clockOut` trả hàm hoàn tác. */
export function useClockOuts() {
  const map = useSyncExternalStore(subscribe, () => outs);
  const clockOut = useCallback((owner: string, day: string, t: string) => {
    const key = `${owner}:${day}`;
    const prev = outs.get(key) ?? null;
    setOut(key, t);
    return () => setOut(key, prev);
  }, []);
  return { map, clockOut };
}
